<template>
  <v-container>
    <v-data-table
      :headers="headers"
      :items="setupDatas"
      hide-default-footer
      class="elevation-1"
      :items-per-page="itemsPerPage"
    >
      <template v-slot:top>
        <v-toolbar flat color="white">
          <v-toolbar-title class="mr-2">Setup Data</v-toolbar-title>
          <v-dialog v-model="dialog" max-width="500px" persistent>
            <template v-slot:activator="{ on }">
              <v-btn color="primary" dark class="mb-2" v-on="on" small
                ><v-icon class="white--text">mdi-plus</v-icon></v-btn
              >
            </template>
            <v-card>
              <v-card-title>
                <span class="headline">{{ formTitle }}</span>
              </v-card-title>

              <v-card-text>
                <v-container>
                  <v-select
                    v-model="editedItem.type"
                    :items="typeOptions"
                    item-text="text"
                    item-value="value"
                    label="Tipe Setup Data"
                    :disabled="editedIndex !== -1"
                  ></v-select>

                  <!-- KOMISI -->
                  <template v-if="editedItem.type === 'komisi'">
                    <v-select
                      v-model="editedItem.jenis_komisi"
                      :items="jenisHitungOptions"
                      label="Jenis Komisi"
                    ></v-select>
                    <v-text-field
                      v-model.number="editedItem.besar_komisi"
                      label="Besar Komisi"
                      type="number"
                    ></v-text-field>
                  </template>

                  <!-- DENDA -->
                  <template v-else-if="editedItem.type === 'denda'">
                    <v-text-field
                      v-model.number="editedItem.jumlah"
                      label="Jumlah Denda"
                      type="number"
                    ></v-text-field>
                  </template>

                  <!-- PERIODE -->
                  <template v-else-if="editedItem.type === 'periode'">
                    <v-text-field
                      v-model="editedItem.periode_awal"
                      label="Periode Awal"
                      type="date"
                    ></v-text-field>
                    <v-text-field
                      v-model="editedItem.periode_akhir"
                      label="Periode Akhir"
                      type="date"
                    ></v-text-field>
                    <v-text-field
                      v-model.number="editedItem.tgl_jatuh_tempo"
                      label="Tanggal Jatuh Tempo (1-31)"
                      type="number"
                      min="1"
                      max="31"
                    ></v-text-field>
                  </template>

                  <!-- LIFETIME -->
                  <template v-else-if="editedItem.type === 'lifetime'">
                    <v-select
                      v-model="editedItem.jenis_benefit"
                      :items="jenisBenefitOptions"
                      label="Jenis Benefit"
                    ></v-select>
                    <v-text-field
                      v-model.number="editedItem.besar_benefit"
                      label="Besar Benefit"
                      type="number"
                    ></v-text-field>
                    <v-text-field
                      v-model="editedItem.periode_awal"
                      label="Periode Awal (opsional)"
                      type="date"
                      clearable
                    ></v-text-field>
                    <v-text-field
                      v-model="editedItem.periode_akhir"
                      label="Periode Akhir (opsional)"
                      type="date"
                      clearable
                    ></v-text-field>
                  </template>

                  <v-row>
                    <v-col
                      cols="12"
                      sm="6"
                      md="6"
                      v-if="editedItem.type !== 'lifetime'"
                    >
                      <v-switch
                        v-model="editedItem.is_multiple"
                        inset
                        :label="watchMultiple"
                      ></v-switch>
                    </v-col>
                    <v-col cols="12" sm="6" md="6">
                      <v-switch
                        v-model="editedItem.statusBool"
                        inset
                        :label="watchStatus"
                      ></v-switch>
                    </v-col>
                  </v-row>
                </v-container>
              </v-card-text>

              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="textGrey" text @click="close">Batal</v-btn>
                <v-btn color="accent" text @click="save">Simpan</v-btn>
              </v-card-actions>
            </v-card>
          </v-dialog>
        </v-toolbar>
      </template>

      <template v-slot:item.actions="{ item }">
        <v-btn
          small
          @click="editItem(item)"
          width="80"
          color="warn"
          class="mr-1"
        >
          <v-icon small>mdi-pencil</v-icon> Edit
        </v-btn>
        <v-btn small @click="hapusItem(item)" width="80" color="error">
          <v-icon small>mdi-delete</v-icon> Hapus
        </v-btn>
      </template>

      <template v-slot:no-data> Belum ada data setup... </template>
    </v-data-table>

    <div class="text-center pt-2">
      <v-pagination
        v-model="page"
        :length="pageCount"
        @input="search"
      ></v-pagination>
    </div>
  </v-container>
</template>

<script>
import SetupDataAPIServices from "../services/SetupDataAPIServices";
require("firebase/auth");

import { mapMutations } from "vuex";

export default {
  name: "SetupData",

  data: () => ({
    sessionNIK: "",
    dialog: false,

    typeOptions: [
      { text: "Komisi", value: "komisi" },
      { text: "Denda", value: "denda" },
      { text: "Periode", value: "periode" },
      { text: "Lifetime", value: "lifetime" },
    ],
    jenisHitungOptions: [
      { text: "Persentase", value: "percentage" },
      { text: "Nominal", value: "nominal" },
    ],
    jenisBenefitOptions: [
      { text: "Persentase", value: "Persentase" },
      { text: "Nominal", value: "Nominal" },
    ],

    headers: [
      { text: "ID", align: "start", value: "id", sortable: false },
      { text: "Tipe", value: "textType", sortable: false },
      { text: "Detail", value: "textDetail", sortable: false },
      { text: "Status", value: "textStatus", sortable: false },
      { text: "Action", value: "actions", sortable: false },
    ],
    setupDatas: [],

    editedIndex: -1,
    editedItem: {
      id: null,
      type: "komisi",
      status: "1",
      statusBool: true,
      is_multiple: false,
      jenis_komisi: "percentage",
      besar_komisi: null,
      jumlah: null,
      periode_awal: null,
      periode_akhir: null,
      tgl_jatuh_tempo: null,
      jenis_benefit: "Persentase",
      besar_benefit: null,
    },
    defaultItem: {
      id: null,
      type: "komisi",
      status: "1",
      statusBool: true,
      is_multiple: false,
      jenis_komisi: "percentage",
      besar_komisi: null,
      jumlah: null,
      periode_awal: null,
      periode_akhir: null,
      tgl_jatuh_tempo: null,
      jenis_benefit: "Persentase",
      besar_benefit: null,
    },

    page: 1,
    pageCount: 1,
    itemsPerPage: 10,
  }),

  watch: {
    dialog(val) {
      val || this.close();
    },
  },

  created() {
    this.initialize();
  },

  computed: {
    formTitle() {
      return this.editedIndex === -1 ? "Tambah Setup Data" : "Edit Setup Data";
    },
    watchStatus() {
      return this.editedItem.statusBool === true ? "Aktif" : "Tidak Aktif";
    },
    watchMultiple() {
      return this.editedItem.is_multiple === true ? "Multiple" : "Single";
    },
  },

  methods: {
    async initialize() {
      if (this.$session.exists()) {
        try {
          this.sessionNIK = this.$session.get("nik");
        } catch (e) {
          this.$store.commit("logout");
        }
      } else {
        this.$store.commit("logout");
      }
      this.page = 1;
      this.search();
    },

    mapRow(item) {
      // status bisa berupa angka (1/0) atau string ("1"/"0")
      const aktif = item.status == 1;
      item.statusBool = aktif;
      item.textStatus = aktif ? "Aktif" : "Tidak Aktif";

      const typeOpt = this.typeOptions.find((t) => t.value === item.type);
      item.textType = typeOpt ? typeOpt.text : item.type;

      switch (item.type) {
        case "komisi":
          item.textDetail =
            item.jenis_komisi + " — " + (item.besar_komisi ?? "-");
          break;
        case "denda":
          item.textDetail = "Jumlah: " + (item.jumlah ?? "-");
          break;
        case "periode":
          item.textDetail =
            (item.periode_awal || "-") +
            " s/d " +
            (item.periode_akhir || "-") +
            " (jatuh tempo: " +
            (item.tgl_jatuh_tempo ?? "-") +
            ")";
          break;
        case "lifetime":
          item.textDetail =
            item.jenis_benefit + " — " + (item.besar_benefit ?? "-");
          break;
        default:
          item.textDetail = "-";
      }
      return item;
    },

    search() {
      this.setupDatas = [];
      this.$store.commit("showProgress", {
        message: "Mengambil data setup",
      });
      SetupDataAPIServices.getAll(this.itemsPerPage, this.page, "new")
        .then((response) => {
          response.data.data.forEach((item) => {
            this.setupDatas.push(this.mapRow(item));
          });
          this.page = response.data.current_page;
          this.pageCount = response.data.last_page;
        })
        .catch((error) => {
          this.handleError(error, "Setup Data gagal di muat");
        })
        .finally(() => {
          this.$store.commit("closeProgress");
        });
    },

    editItem(item) {
      this.editedIndex = this.setupDatas.indexOf(item);
      this.editedItem = Object.assign({}, item);
      this.editedItem.statusBool = item.status == 1;
      this.editedItem.is_multiple = item.is_multiple == true || item.is_multiple == 1;
      this.dialog = true;
    },

    hapusItem(item) {
      confirm("Hapus Setup Data #" + item.id + " (" + item.type + ")?") &&
        (this.$store.commit("showProgress", {
          message: "Proses menghapus setup data",
        }),
        SetupDataAPIServices.delete(item.id)
          .then(() => {
            this.showSnackbar({
              color: "secondary",
              message: "Setup Data berhasil di hapus",
            });
            this.initialize();
          })
          .catch((error) => {
            this.handleError(error, "Setup Data gagal dihapus");
          })
          .finally(() => {
            this.$store.commit("closeProgress");
          }));
    },

    close() {
      this.dialog = false;
      setTimeout(() => {
        this.editedItem = Object.assign({}, this.defaultItem);
        this.editedIndex = -1;
      }, 300);
    },

    // Validasi field wajib per type. Return pesan error atau null jika valid.
    validateByType() {
      const item = this.editedItem;
      if (!item.type) return "Tipe wajib dipilih.";

      switch (item.type) {
        case "komisi":
          if (!item.jenis_komisi) return "Jenis komisi wajib dipilih.";
          if (item.besar_komisi === null || item.besar_komisi === "")
            return "Besar komisi wajib diisi.";
          break;
        case "denda":
          if (item.jumlah === null || item.jumlah === "")
            return "Jumlah denda wajib diisi.";
          break;
        case "periode":
          if (!item.periode_awal) return "Periode awal wajib diisi.";
          if (!item.periode_akhir) return "Periode akhir wajib diisi.";
          if (item.tgl_jatuh_tempo === null || item.tgl_jatuh_tempo === "")
            return "Tanggal jatuh tempo wajib diisi.";
          if (item.tgl_jatuh_tempo < 1 || item.tgl_jatuh_tempo > 31)
            return "Tanggal jatuh tempo harus antara 1-31.";
          break;
        case "lifetime":
          if (!item.jenis_benefit) return "Jenis benefit wajib dipilih.";
          if (item.besar_benefit === null || item.besar_benefit === "")
            return "Besar benefit wajib diisi.";
          break;
      }
      return null;
    },

    // Bangun payload sesuai type agar tidak mengirim field tidak relevan.
    buildPayload() {
      const item = this.editedItem;
      const payload = {
        type: item.type,
        status: item.statusBool ? "1" : "0",
      };

      switch (item.type) {
        case "komisi":
          payload.is_multiple = item.is_multiple;
          payload.jenis_komisi = item.jenis_komisi;
          payload.besar_komisi = item.besar_komisi;
          break;
        case "denda":
          payload.is_multiple = item.is_multiple;
          payload.jumlah = item.jumlah;
          break;
        case "periode":
          payload.is_multiple = item.is_multiple;
          payload.periode_awal = item.periode_awal;
          payload.periode_akhir = item.periode_akhir;
          payload.tgl_jatuh_tempo = item.tgl_jatuh_tempo;
          break;
        case "lifetime":
          payload.jenis_benefit = item.jenis_benefit;
          payload.besar_benefit = item.besar_benefit;
          payload.periode_awal = item.periode_awal || null;
          payload.periode_akhir = item.periode_akhir || null;
          break;
      }
      return payload;
    },

    save() {
      const errorMessage = this.validateByType();
      if (errorMessage) {
        this.showSnackbar({ color: "error", message: errorMessage });
        return;
      }

      const payload = this.buildPayload();

      if (this.editedIndex === -1) {
        payload.createwho = this.sessionNIK;
        this.$store.commit("showProgress", {
          message: "Proses menambah setup data",
        });
        SetupDataAPIServices.create(payload)
          .then(() => {
            this.close();
            this.showSnackbar({
              color: "secondary",
              message: "Data berhasil ditambah",
            });
            this.initialize();
          })
          .catch((error) => {
            this.handleError(error, "Setup Data gagal di tambah");
          })
          .finally(() => {
            this.$store.commit("closeProgress");
          });
      } else {
        payload.updatewho = this.sessionNIK;
        this.$store.commit("showProgress", {
          message: "Proses mengedit setup data",
        });
        SetupDataAPIServices.edit(this.editedItem.id, payload)
          .then(() => {
            this.close();
            this.showSnackbar({
              color: "secondary",
              message: "Data berhasil di edit",
            });
            this.initialize();
          })
          .catch((error) => {
            this.handleError(error, "Setup Data gagal di edit");
          })
          .finally(() => {
            this.$store.commit("closeProgress");
          });
      }
    },

    handleError(error, fallbackMessage) {
      if (error.response) {
        if (error.response.data && error.response.data.message) {
          this.showSnackbar({
            color: "error",
            message: error.response.data.message,
          });
        } else {
          this.showSnackbar({ color: "error", message: fallbackMessage });
        }
      } else if (error.request) {
        this.showSnackbar({
          color: "error",
          message: "Koneksi ke server gagal (ERROR)",
        });
      } else {
        this.showSnackbar({ color: "error", message: fallbackMessage });
      }
    },

    ...mapMutations(["showSnackbar"]),
  },
};
</script>
